export const environment = {
  isProdEnv: false,
  production: true,
  i18nDirectory: "./assets/i18n/",
  application_url: "https://dev.geologyontario.mines.gov.on.ca/",
  apim_url: "https://ws.test.apis.lrc.gov.on.ca/mndm/geology/search",
  serviceSubscriptionKey: 'a6e87ee389144174ba3dfb856bed9d4b',
  azure_blob_storage: "https://ist-0420-geoontario-0000-blob-dzarcxdwg7dph4hk.z01.azurefd.net/lrc-geology-documents/"
};